import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResponseModel } from 'src/app/shared/models/ResponseModel';
import { environment } from 'src/environments/environment';
import { MiAdmPersonasAcademicos } from '../interfaces/IAdmPersonAcademic';

@Injectable({
  providedIn: 'root'
})
export class PersonAcademicService {
  private apiUrl = environment.backUrlApi + 'PersonAcademic';
  private http = inject(HttpClient);

  /** Obtener todos los registros académicos */
  getAll(): Observable<ResponseModel<MiAdmPersonasAcademicos[]>> {
    return this.http.get<ResponseModel<MiAdmPersonasAcademicos[]>>(`${this.apiUrl}`);
  }

  /** Crear registro académico completo */
  createFull(id: string, body: MiAdmPersonasAcademicos): Observable<ResponseModel<MiAdmPersonasAcademicos>> {
    return this.http.post<ResponseModel<MiAdmPersonasAcademicos>>(`${this.apiUrl}/create-full?id=${id}`, body);
  }

  /** Obtener registros académicos por Id */
  getById(id: string): Observable<ResponseModel<MiAdmPersonasAcademicos[]>> {
    return this.http.get<ResponseModel<MiAdmPersonasAcademicos[]>>(`${this.apiUrl}/by-id?id=${encodeURIComponent(id)}`);
  }

  /** Eliminar registro académico por Id */
  delete(idEncrypted: string, idDeleted: string): Observable<ResponseModel<MiAdmPersonasAcademicos>> {
    return this.http.delete<ResponseModel<MiAdmPersonasAcademicos>>(
      `${this.apiUrl}/delete?idEncrypted=${encodeURIComponent(idEncrypted)}&idDeleted=${idDeleted}`
    );
  }

  /** Actualizar registro académico completo */
  updateFull(id: string, body: MiAdmPersonasAcademicos): Observable<ResponseModel<MiAdmPersonasAcademicos>> {
    return this.http.put<ResponseModel<MiAdmPersonasAcademicos>>(`${this.apiUrl}/update-full?id=${id}`, body);
  }
}
